module.exports = __webpack_public_path__ + "合作7.png?5e5d4eaa30e79babe53158ddde581dbd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作7.png
// module id = 649
// module chunks = 0